/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Options de civilité valant directement la LETTRE stockée en base.
 *
 * Distinct d'`OPTIONS_SEXE` de la lib, adossé à son enum `Sexe` puis converti
 * en code INSEE 1/2 par `formatSexe` : la colonne `ec_actd.ad_df_sexex`
 * (civilité du conjoint du défunt) stocke une lettre.
 *
 * Évite une conversion aller-retour entre trois représentations pour un champ
 * qui n'en demande aucune : ce qui est affiché est ce qui est stocké.
 */
export const OPTIONS_SEXE_LETTRE = [
  { key: 'M', value: 'M', text: 'Masculin' },
  { key: 'F', value: 'F', text: 'Féminin' },
  // `I` existe déjà en base : l'omettre rendait ces actes non modifiables sans
  // écraser leur valeur.
  { key: 'I', value: 'I', text: 'Indéterminé' },
];

export default OPTIONS_SEXE_LETTRE;
